import { render, staticRenderFns } from "./FirebaseCrud.vue?vue&type=template&id=66324e0e&scoped=true"
import script from "./FirebaseCrud.vue?vue&type=script&lang=js"
export * from "./FirebaseCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66324e0e",
  null
  
)

export default component.exports